<!-- test_help_info.vue -->
<template>
  <div>
    <help-info-wrapper :info.sync="helpData" :service-name="serviceName">
      <!-- <template v-slot="{ helpData }"> -->
      <div class="testmain">
        <!-- نمونه برای بدون داده که مدیریت بتونه داده اضافه کنه -->

        <div v-for="i in 3" :key="i">
          <v-btn> test </v-btn>
          <help-info
            :element-name="`test000232-${i}`"
            :help-data="helpData"
            label="تستی"
            :service-name="serviceName"
          />
        </div>

        <div v-if="categories.length > 0">
          <div
            v-for="(category, catIndex) in categories"
            :key="catIndex"
            class="category"
          >
            <h3>{{ category.name }}</h3>
            <div class="test">
              <div
                v-for="(item, index) in category.elements"
                :key="index"
                class="element"
              >
                <v-btn color="navy">{{ item.name }}</v-btn>
                <help-info
                  :element-name="item.name"
                  :service-name="serviceName"
                  :help-data="helpData"
                  :label="item.title"
                />
              </div>
            </div>
          </div>
        </div>
        <div v-else class="no-data">
          <p>هیچ اطلاعاتی برای سرویس {{ serviceName }} یافت نشد.</p>
        </div>
      </div>
      <!-- </template> -->
    </help-info-wrapper>
  </div>
</template>

<script>
import helpInfo from "./help_info.vue";
import HelpInfoWrapper from "./HelpInfoWrapper.vue";
import { GetFile } from "./GuideContent_axios";

export default {
  name: "test_help_info",
  components: { helpInfo, HelpInfoWrapper },
  data() {
    return {
      serviceName: "Coreland",
      categories: [],
      helpData: [],
    };
  },
  created() {
    this.fetchData();
  },

  methods: {
    fetchData() {
      this.loading = true;

      GetFile(this.serviceName)
        .then((data) => {
          if (data.length > 0) {
            console.log(data[0], "data");
            this.categories = this.processData(data[0]);
          }
        })
        .catch((error) => {
          console.error("خطا در دریافت داده‌ها:", error);
          this.categories = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    processData(data) {
      if (!data || data.length === 0) return [];
      console.log("data", data);
      const categoryMap = {};
      data.forEach((item) => {
        console.log("item", item);

        const catId = item.category_id || "Uncategorized";
        if (!categoryMap[catId]) {
          categoryMap[catId] = {
            name: item.category || `دسته ${catId}`,
            elements: [],
          };
        }
        categoryMap[catId].elements.push(item);
      });
      console.log(categoryMap);
      return Object.values(categoryMap);
    },
  },
};
</script>

<style scoped>
.testmain {
  display: flex;
  flex-direction: column;
  gap: 15px;
  justify-content: center;
  align-items: flex-start;
  padding: 20px;
}
.category {
  width: 100%;
}
.test {
  display: flex;
  flex-direction: row;
  gap: 5px;
  justify-content: flex-start;
  align-items: baseline;
  flex-wrap: wrap;
}
.element {
  display: flex;
  align-items: center;
  gap: 5px;
}
.no-data {
  text-align: center;
  color: #666;
}
</style>
